module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/ian_sara_silly-8139b5d7a02986b6a0cea289575bc98a.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/ian_sara_silly.png
// module id = 2446
// module chunks = 2